/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Maxim Fedorov
 * @version 1.1.0
 * @since 1.0.1
 */

import { ResponsiveType } from 'react-multi-carousel';

import { IChartPieItem } from '../../../../../../components/common/Chart/ChartPie/chartPieTypes';

export interface IWidgetConfiguration {
    carousel: {
        responsive: ResponsiveType;
    };
    chart: {
        colors: {[K in EWidgetCostsChart]: string};
        innerRadius: number;
        legendSize: number;
        padding: [number, number, number, number];
        radius: number;
        size: number;
        strokeColor: string;
        yearLimit: number;
    };
    chartEmpty: {
        data: IChartPieItem[];
    };
    dateFormat: string;
    dateFormatRedirect: string;
    initDataFrom: string;
    initDateTo: string;
    skeleton: {
        multiple: number;
    };
}

export enum EWidgetCostsChart {
    ONE_TIME_CHARGES = 'oneTimeCharges',
    OTHER_RECURRING_CHARGES = 'otherRecurringCharges',
    RECURRING_CHARGES_FOR_RATE_PLAN = 'recurringChargesForRatePlan',
    TRAFFIC_CHARGES_AT_HOME_MACRO_REGION_AND_NOT_IN_HOME_REGION = 'trafficChargesAtHomeMacroRegionAndNotInHomeRegion',
    TRAFFIC_CHARGES_AT_HOME_REGION = 'trafficChargesAtHomeRegion',
    TRAFFIC_CHARGES_AT_OUT_HOME_MACRO_REGION = 'trafficChargesAtOutHomeMacroRegion',
    TRAFFIC_CHARGES_AT_ROAMING = 'trafficChargesAtRoaming',
}

export type TWidgetCostsChartValue = {
    chart: { [K in EWidgetCostsChart]?: number };
    totalOfBasicChargesAggregates: number;
};

